import React from 'react';
import TournamentInformation from '../../components/customLayout/TournamentInformation';

const TournamentPreviewTab: React.FC = () => {
  return (
    <>
      <TournamentInformation fullview />
    </>
  );
};

export default TournamentPreviewTab;
